// Consolidated `/admin/compliance` page — the two compliance surfaces
// (ISO/IEC 27001 Annex A controls + SOC 2 Trust-Service-Criteria
// evidence-engine) fold into one tabbed shell so the operator who is
// preparing for an audit finds both controls-mapping and evidence-
// generation on one page (item 91 Phase B of PRODUCT-ROADMAP.md):
//
//   * ISO 27001 — live Annex A snapshot + filterable controls table
//   * SOC 2     — generate auditor-ready evidence ZIP + past runs
//
// The active tab is driven by URL fragment (`/admin/compliance#soc2`).
// The legacy URLs `/admin/compliance/iso27001` + `/admin/compliance/soc2`
// `<Navigate replace />` to the matching anchor in App.tsx so existing
// bookmarks keep working.

import { ClipboardCheck, Shield } from 'lucide-react';
import { AdminShell } from '../../components/AdminShell';
import { Tabs, type TabItem } from '../../components/ui/Tabs';
import { AdminComplianceIso27001Tab } from './AdminComplianceIso27001Tab';
import { AdminComplianceSoc2Tab } from './AdminComplianceSoc2Tab';

const TABS: TabItem[] = [
  {
    id: 'iso27001',
    label: (
      <span className="flex items-center gap-2">
        <Shield className="h-4 w-4" />
        ISO 27001
      </span>
    ),
    panel: <AdminComplianceIso27001Tab />,
  },
  {
    id: 'soc2',
    label: (
      <span className="flex items-center gap-2">
        <ClipboardCheck className="h-4 w-4" />
        SOC 2
      </span>
    ),
    panel: <AdminComplianceSoc2Tab />,
  },
];

export function AdminCompliance() {
  return (
    <AdminShell
      title={
        <span className="flex items-center gap-2">
          <Shield className="h-5 w-5 text-nebula" />
          Compliance
        </span>
      }
      description="One surface for the two compliance frameworks an auditor will ask about: ISO/IEC 27001:2022 Annex A controls-mapping with live point-in-time probes, and the SOC 2 Trust-Service-Criteria evidence-engine that produces auditor-ready ZIP bundles with a server-side hash counterpart."
    >
      <Tabs items={TABS} defaultId="iso27001" ariaLabel="Compliance frameworks" />
    </AdminShell>
  );
}
